import { ChevronRightIcon } from '@heroicons/react/24/solid'
import { useState } from 'react'
import { UpgradeModal } from '../UpgradeModal'

export function UpgradeBanner() {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <div className="mx-2 mb-3 mt-3 rounded-lg bg-blue-50 p-3">
        <p className="text-xs text-default">
          Upgrade to unlock more CRM features like lead management and attribution.
        </p>
        <button
          onClick={() => setShowModal(true)}
          className="mt-2 flex w-full items-center justify-center gap-1 rounded-md bg-blue-600 px-3 py-2 text-xs font-medium text-on-color hover:bg-blue-700"
        >
          Upgrade now
          <ChevronRightIcon className="h-3 w-3" />
        </button>
      </div>
      <UpgradeModal open={showModal} onClose={() => setShowModal(false)} />
    </>
  )
}
